import React from 'react';

import cx from 'classnames';

import LinkV2, { LinkV2Props } from '../../LinkV2/LinkV2';
import { createKeyClickHandler } from '../../../util/handleKeys';
import styles from './removeFromCartButton.module.less';

export const RemoveFromCartButton = ({
  className,
  removeFromCart,
}: LinkV2Props & { removeFromCart: () => Promise<void> }) => {
  const removeKeyHandler = createKeyClickHandler(() => {
    removeFromCart().catch(() => null);
  });

  return (
    <LinkV2
      role="button"
      className={cx(styles.removeFromCartButton, className)}
      onClick={removeFromCart}
      onKeyUp={removeKeyHandler}
      tabIndex={0}
    >
      Remove
    </LinkV2>
  );
};
